/**
 * Supplier API error (AWS).
 */
import { JSONParseSafe } from '@/utils/json';
import { FetchError } from '../fetchError';

export type SupplierApiErrorBody = {
  type: string;
  title: string;
  status: number;
  traceId: string;
  errors: Record<string, string[]>;
  // there can be more fields
};

export class SupplierApiError extends FetchError {
  parsedBody!: SupplierApiErrorBody;

  static tryCreateFromUnknownError(e: unknown) {
    if (!(e instanceof FetchError)) return;

    const parsedBody = JSONParseSafe<SupplierApiErrorBody>(e.body);
    if (!parsedBody?.title) return;

    const error = new SupplierApiError(parsedBody.title, e);
    error.parsedBody = parsedBody;

    return error;
  }
}

// See: https://github.com/sindresorhus/serialize-error/issues/106
Object.defineProperty(SupplierApiError, 'name', { value: 'SupplierApiError' });
